module.exports = __webpack_public_path__ + "img/catabocata1.e0f3fbc5.png";